import CONFIG from "../../../model/TSConfig";

function stripBaseNameFromPathName() {
  return window.location.pathname.replace(CONFIG.baseName + "/", "");
}

export function splitPathName() {
  const pathname = stripBaseNameFromPathName();
  return pathname.split("/").filter(Boolean);
}

export function extractTrackingIDFromURL() {
  const split = splitPathName();

  if (!split.length) {
    return null;
  }

  // SaaS customers have tracking IDs which start with bu_
  // Non-SaaS customers have tracking IDs which have 24 characters
  if (split[0].startsWith("bu_") || split[0].length === 24) {
    return split[0];
  }

  return null;
}
